/* eslint-disable no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';

const getDefaultState = () => {
  return {
    unsavedData: false,
    validationError: false,
    firstName: '',
    bidType: 1,
  };
};

const accountSettingsSlice = createSlice({
  name: 'accountSettings',
  initialState: getDefaultState(),
  reducers: {
    updateProperty: (state, action) => {
      state[action.payload.propField] = action.payload.newValue;
      state.unsavedData = true;
    },
    resetSettingsObject: (state) => {
      state.firstName = '';
      state.bidType = 1;
      state.unsavedData = true;
    },
  },
});

export const accountSettingsActions = accountSettingsSlice.actions;
export default accountSettingsSlice.reducer;
